/* eslint-disable style/no-tabs */
import { useTranslation } from "react-i18next";

function SecurityFailedExpired() {
  const { t } = useTranslation("security");

  return (
    <>
      <p>
        {t("security:kyc-failed-expired-intro")}
        {/* We regret to inform you that your recent submission for the verification
				process has encountered an issue due to a session timeout.
				Unfortunately, your session was not completed within the allotted time,
				resulting in an incomplete submission. */}
      </p>
      <div class="w-full h-4" />
      <p>
        {t("security:kyc-failed-expired-header")}
        {/* To address this issue and successfully complete your verification, we
				recommend the following steps: */}
      </p>
      <div class="w-full h-4" />
      <ul>
        <li class="list-disc pl-2 ml-4">
          <strong>
            {t("security:kyc-failed-expired-list-header-1")}
            {" "}
            {/* Start a New Session: */}
          </strong>
          {t("security:kyc-failed-expired-list-item-1")}
          {/* Please initiate a new KYC session by logging into your account and
					following the KYC verification process once again. */}
        </li>
        {" "}
        <li class="list-disc pl-2 ml-4">
          <strong>
            {t("security:kyc-failed-expired-list-header-2")}
            {" "}
            {/* Complete the Process Promptly: */}
          </strong>
          {t("security:kyc-failed-expired-list-item-2")}
          {/* To prevent another session timeout, please ensure that you complete
					all necessary steps within the designated time limit. We recommend
					having all required documents and information ready before beginning
					the process. */}
        </li>
        {" "}
      </ul>
      <div class="w-full h-4" />
      <p>
        {t("security:kyc-failed-expired-ending")}
        {/* We look forward to assisting you in completing your verification
				successfully. */}
      </p>
    </>
  );
}

export default SecurityFailedExpired;
